import { classNames } from "primereact/utils";
import styles from "./KeyValueItem.module.scss";
import { AppTooltip } from "../../../../common/components/tooltip/AppTooltip";

interface IKeyValueItemProps {
  className?: string;
  name: string;
  value?: string | number | JSX.Element;
  valueClassName?: string;
  tooltip?: string;
}

export const KeyValueItem = ({
  className,
  name,
  value = "",
  valueClassName,
  tooltip,
}: IKeyValueItemProps) => {
  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.root_name}>
        {name}
        <AppTooltip content={tooltip} />
      </div>
      <div className={classNames(styles.root_value, valueClassName)}>
        {value}
      </div>
    </div>
  );
};
